import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

const NO_REFRESH = /\/auth\/(login|register|refresh|google|logout)/;
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    if (error.response?.status === 401 && !cfg._retry && !NO_REFRESH.test(cfg.url || "")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
      } catch (e) {
        refreshing = null;
        return Promise.reject(error);
      }
      refreshing = null;
      return api(cfg);
    }
    return Promise.reject(error);
  }
);

export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail?.msg || String(detail);
}

export const mediaSrc = (url) => (url ? `${BACKEND}${url}` : null);

export async function startCheckout(payload) {
  const { data } = await api.post("/payments/checkout", { ...payload, origin_url: window.location.origin });
  sessionStorage.setItem("ar_checkout_kind", payload.kind);
  window.location.href = data.checkout_url;
}

export const TIER_LABEL = { fan: "Fan", vip: "VIP", inner: "Inner Circle" };
export const TIER_RANK = { fan: 1, vip: 2, inner: 3 };
export const FALLBACK_TIERS = [
  { id: "fan", name: "Fan", price: 50, perks: ["Full access to every Fan post", "Direct messages with Katie", "Like, comment & send tips"] },
  { id: "vip", name: "VIP", price: 100, perks: ["Everything in Fan", "VIP-only photos & videos", "VIP badge on your comments"] },
  { id: "inner", name: "Inner Circle", price: 250, perks: ["Everything in VIP", "The Inner Circle vault", "Priority in Katie's inbox"] },
];

export const homeFor = (user) => (user?.role === "admin" ? "/studio" : user?.tier ? "/feed" : "/join");
